import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';
import type { FormlyHookFn } from './formly-hook-fn.type';

export const refreshSolarStorageEquipmentValidationHook = (
  destroyed$
): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    field.formControl?.valueChanges
      .pipe(takeUntil(destroyed$))
      .subscribe(() => {
        const equipmentControl = field.formControl?.parent;
        equipmentControl?.get('inverters')?.updateValueAndValidity();
        equipmentControl?.get('batteries')?.updateValueAndValidity();
      });
  };
};
